export default "__VITE_ASSET__CFizRrh8__"